var _path, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 8C20 8 12 16 12 26C12 32 15 37 20 41V45C20 47 22 49 24 49H36C38 49 40 47 40 45V41C45 37 48 32 48 26C48 16 40 8 30 8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49V52C24 54 26 56 28 56H32C34 56 36 54 36 52V49",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56H34",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 3,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25L35 35M35 25L25 35",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvent);
export default __webpack_public_path__ + "static/media/invent.9ac8d058f700e2fe37fe918a7000e8e2.svg";
export { ForwardRef as ReactComponent };